import type { FC, PropsWithChildren } from 'react'

import React from 'react'

import styled from '@emotion/styled'

import Divider from '@segment/matcha/components/Divider'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import TrendSection from './TrendSection'

import { trends } from './data'

const copy = {
  heading: `Key findings`,
}

const KeyFindings: FC<PropsWithChildren<unknown>> = () => {
  return (
    <StyledSectionBase variant="centered">
      <StyledSectionCopy>
        <CopyTextBase>
          <UppercaseCopyTextOverline tag="h2" variant="overline">
            {copy.heading}
          </UppercaseCopyTextOverline>
        </CopyTextBase>
        <StyledDivider />
      </StyledSectionCopy>
      <Section.Contents>
        {trends.map(({ order, ...trendProps }) => (
          <React.Fragment key={order}>
            <TrendSection order={order} {...trendProps} />
            <Divider />
          </React.Fragment>
        ))}
      </Section.Contents>
    </StyledSectionBase>
  )
}

const UppercaseCopyTextOverline = styled(CopyText.Overline)`
  text-transform: uppercase;
`

const StyledSectionBase = styled(SectionBase)`
  > ${Section.Wrapper} {
    row-gap: 0;
    justify-content: unset;
    margin: 0;
    padding-bottom: 0;
  }
`

const StyledSectionCopy = styled(Section.Copy)`
  width: 100%;
`

const StyledDivider = styled(Divider)`
  margin: 25px 0 0;
`

export default KeyFindings
